var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 325.498 325.498",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_5_45_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.998,289.047c0,8.25-6.75,15-15,15h-62c-8.25,0-15-6.75-15-15v-68c0-8.25,6.75-15,15-15h62c8.25,0,15,6.75,15,15 V289.047z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M215.248,289.047c0,8.25-6.75,15-15,15h-62c-8.25,0-15-6.75-15-15v-104c0-8.25,6.75-15,15-15h62c8.25,0,15,6.75,15,15 V289.047z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M325.498,289.047c0,8.25-6.75,15-15,15h-62c-8.25,0-15-6.75-15-15v-144c0-8.25,6.75-15,15-15h62c8.25,0,15,6.75,15,15 V289.047z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.522,21.731l-67.375,16.392c-5.346,1.294-6.537,5.535-2.648,9.424l14.377,14.041 c1.207,1.376-0.225,3.206-1.361,3.981c-9.053,6.18-23.42,15.248-43.279,25.609c-108.115,56.407-197.238,52.947-198.578,52.886 c-7.154-0.363-13.271,5.148-13.641,12.314c-0.369,7.17,5.143,13.283,12.313,13.652c0.527,0.027,2.67,0.124,6.273,0.124 c23.107,0,106.111-3.987,205.66-55.924c23.555-12.289,39.881-22.888,49.414-29.598c1.348-0.949,3.697-2.585,5.865-0.378 l15.725,15.724c3.889,3.889,8.109,2.692,9.381-2.659l15.285-68.211C321.203,23.756,317.867,20.437,312.522,21.731z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.e32d56df5920bb1f290da3bd4f4e130e.svg";
export { ForwardRef as ReactComponent };